import { useEffect } from 'react'
import { THEME, themeVars } from './theme'
import BottomNav from './components/BottomNav'
import Awards from './screens/Awards'
import Friends from './screens/Friends'
import Home from './screens/Home'
import Profile from './screens/Profile'
import Result from './screens/Result'
import Session from './screens/Session'
import { gameStore, useGame } from './game/useGame'
import type { Screen } from './game/types'

const NAV_SCREENS: Screen[] = ['home', 'friends', 'awards', 'profile']

export default function App() {
  const state = useGame()

  useEffect(() => {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME.bg)
  }, [])

  // Время в фоновой вкладке — не занятие, а гонка не должна тикать на паузе.
  useEffect(() => {
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') gameStore.pause()
      else gameStore.resume()
    }
    document.addEventListener('visibilitychange', onVisibility)
    window.addEventListener('pagehide', gameStore.pause)
    return () => {
      document.removeEventListener('visibilitychange', onVisibility)
      window.removeEventListener('pagehide', gameStore.pause)
    }
  }, [])

  return (
    <div className="app" style={themeVars(THEME)}>
      <div className="app__glow" />

      <div className="app__body">
        {state.screen === 'home' && (
          <Home
            state={state}
            theme={THEME}
            onPlay={gameStore.startSession}
            onScope={gameStore.setScope}
          />
        )}

        {state.screen === 'friends' && <Friends state={state} theme={THEME} store={gameStore} />}

        {state.screen === 'awards' && <Awards state={state} theme={THEME} />}

        {state.screen === 'profile' && (
          <Profile
            state={state}
            theme={THEME}
            store={gameStore}
            onChangeProfile={gameStore.updateProfile}
          />
        )}

        {state.screen === 'session' && <Session state={state} theme={THEME} store={gameStore} />}

        {state.screen === 'result' && (
          <Result
            state={state}
            theme={THEME}
            onAgain={gameStore.startSession}
            onHome={gameStore.goHome}
          />
        )}
      </div>

      {NAV_SCREENS.includes(state.screen) && (
        <BottomNav screen={state.screen} theme={THEME} onNavigate={gameStore.go} />
      )}
    </div>
  )
}
